






































































































import {Vue, Component, Prop, VModel, Watch} from 'vue-property-decorator';
import {v4 as uuidv4} from "uuid";
import {ChangesByCommit} from "@/components/history/dto/ChangesByCommit";
import Change from "@/components/history/dto/Change";
import HistoryRequest from "@/components/history/dto/HistoryRequest";
import HistoryService from "@/components/history/HistoryService";
import moment from "moment";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import ChangeFacadeView from "@/components/history/changeView/ChangeFacadeView.vue";

export type Icon = "xmark" | "arrow-left"
@Component({
	components: {ChangeFacadeView, RightSideBar, BTPortalCollapse}
})
export default class HistorySlider extends Vue {
	@Prop({default: function () {return uuidv4()}})
	private id!: string;

	@Prop({default: "Change History"})
	private title!: string

	@Prop({default: "xmark"})
	private closeIcon!: Icon

	@Prop({required: true})
	private entityId!: any

	@Prop({required: true})
	private domen!: string

	@Prop({required: true})
	private schema!: any

	@VModel({type: Boolean, default: true})
	private model!: boolean

	private expandedCommits: number[] = []
	private changesByCommit: ChangesByCommit[] = []
	private loading = false
	private error: string | null = null
	private selectedFields: string[] = []

	@Watch('model')
	onModelChange(): void {
		this.loadHistory()
	}

	mounted(): void {
		this.loadHistory()
	}

	async loadHistory(): Promise<void> {
		if (!this.entityId || !this.domen) {
			return;
		}

		this.loading = true;
		this.error = null;

		try {
			const request: HistoryRequest = {
				id: this.entityId,
				domen: this.domen,
				fields: this.getSchemaFields(),
				schema: JSON.stringify(this.schema),
			};

			const response = await HistoryService.getHistory(request);
			// Предполагаем, что сервер возвращает массив ChangesByCommit
			this.changesByCommit = Array.isArray(response.data) ? response.data : [];
		} catch (err) {
			this.error = 'Error loading change history';
			console.error('History loading error:', err);
		} finally {
			this.loading = false;
		}
	}
	formatDate(date: Date | string): string {
		return moment(date).format('M.DD.YYYY h:mm A');
	}

	downloadLeft(change: Change<any>) {
		if (change.changeType == 'ReferenceChange'
			&& change.left !== null
			&& change.left.typeName == "com.sublimeaccounting.portal.entity.files.FileMetaEntity") {
			Vue.prototype.$download(change.left.cdoId)
		}
	}

	downloadRight(change: Change<any>) {
		if (change.changeType == 'ReferenceChange'
			&& change.right !== null
			&& change.right.typeName == "com.sublimeaccounting.portal.entity.files.FileMetaEntity") {
			Vue.prototype.$download(change.right.cdoId)
		}
	}

	getChangeTypeText(changeType: string): string {
		const typeMap: { [key: string]: string } = {
			'ValueChange': 'Value Change',
			'ReferenceChange': 'Reference Change',
			'ArrayChange': 'Array Change',
			'ListChange': 'List Change',
			'SetChange': 'Set Change',
			'MultisetChange': 'Multiset Change',
			'InitialValueChange': 'Initial Value',
			'MapChange': 'Map Change',
			'NewObject': 'New Object',
			'ObjectRemoved': 'Object Removed',
			'TerminalValueChange': 'Terminal Value'
		};
		return typeMap[changeType] || changeType;
	}

	formatValue(value: unknown, property: string | null = null): string {
		if (value === null || value === undefined) {
			return '—';
		}

		// Проверяем, является ли это Reference Change объектом
		if (this.isReferenceChangeObject(value)) {
			return this.formatReferenceChangeObject(value, property);
		}


		if (typeof value === 'object') {
			return JSON.stringify(value, null, 2);
		}
		return moment(String(value)).isValid() ? moment(String(value)).format('M.DD.YYYY') : String(value);
	}

	private isReferenceChangeObject(value: any): boolean {
		return value &&
			   typeof value === 'object' &&
			   value.props &&
			   value.cdoId &&
			   value.typeName;
	}

	private formatReferenceChangeObject(value: any, property: string | null = null): string {
		const props = value.props;
		if (!props || typeof props !== 'object') {
			return JSON.stringify(value, null, 2);
		}

		// Формируем список значений согласно схеме
		const formattedValues: string[] = [];

		// Добавляем основные поля из props с использованием схемы для лейблов
		Object.keys(props).forEach(key => {
			const propValue = props[key];
			if (propValue !== null && propValue !== undefined) {
				const label = this.schema[property!][key];
				formattedValues.push(`${label}: ${moment(propValue).isValid() ? moment(propValue).format('M.DD.YYYY') : propValue}`);
			}
		});

		if (formattedValues.length == 0) {
			// Добавляем дополнительную информацию
			if (value.cdoId) {
				formattedValues.push(`ID: ${value.cdoId}`);
			}
			if (value.typeName) {
				const typeName = value.typeName.split('.').pop(); // Берем только имя класса
				formattedValues.push(`Type: ${typeName}`);
			}
		}

		return formattedValues.join('\n');
	}

	getSchemaFields(): string[] | null {
		if (!this.schema) {
			return null;
		}
		
		return Object.keys(this.schema);
	}

	getFieldLabel(propertyName: string): string {
		if (!this.schema) {
			return propertyName;
		}
		
		const fieldValue = this.schema[propertyName];
		if (typeof fieldValue === 'string') {
			return fieldValue;
		} else if (typeof fieldValue === 'object' && fieldValue !== null && fieldValue.label) {
			return fieldValue.label;
		}
		
		return propertyName;
	}

	getFieldAction(propertyName: string): (change: Change<any>) => void {
		const fieldValue = this.schema[propertyName]
		if (typeof fieldValue === 'object' && fieldValue !== null && fieldValue.action) {
			return fieldValue.action;
		} else {
			return () => { return; }
		}
	}

	getChangedFields(changes: Change<unknown>[]): string[] {
		const uniqueFields = new Set<string>();
		changes.forEach(change => {
			uniqueFields.add(change.property);
		});
		return Array.from(uniqueFields); // Показываем максимум 5 полей
	}

	getAllChangedFields(): string[] {
		const allFields = new Set<string>();
		this.changesByCommit.forEach(commit => {
			commit.changes.forEach(change => {
				allFields.add(change.property);
			});
		});
		return Array.from(allFields).sort();
	}

	get filteredCommits(): ChangesByCommit[] {
		if (this.selectedFields.length === 0) {
			return this.changesByCommit;
		}
		
		return this.changesByCommit.filter(commit => {
			return commit.changes.some(change => 
				this.selectedFields.includes(change.property)
			);
		});
	}

	toggleFieldFilter(field: string): void {
		const index = this.selectedFields.indexOf(field);
		if (index > -1) {
			this.selectedFields.splice(index, 1);
		} else {
			this.selectedFields.push(field);
		}
	}

	clearFilters(): void {
		this.selectedFields = [];
	}

}
